module.exports = __webpack_public_path__ + "static/media/sample_candidates.7185dbb8.csv";